import { autoserialize } from 'cerialize';

export class MobilityAidSelection {
  @autoserialize
  seatTransferAssistanceRequired: boolean;

  @autoserialize
  vehicleEquipmentType: string;
}
